/* eslint-disable react-hooks/exhaustive-deps */
import {FC, useContext, useEffect, useMemo, useState} from 'react'
import {useQuery} from 'react-query'

import {useQueryRequest} from './QueryRequestProvider'
import {Transactions} from './_models'
import {getTransactions, getTransactionsListing} from './_requests'
import {useSelector} from 'react-redux'
import {
  createResponseContext,
  initialQueryResponse,
  initialQueryState,
  PaginationState,
  QUERIES,
  stringifyRequestQuery,
  WithChildren,
} from 'src/_metronic/helpers'

const QueryResponseContext = createResponseContext<Transactions>(initialQueryResponse)
const QueryResponseProvider: FC<WithChildren> = ({children}) => {
  const {state} = useQueryRequest()
  const [query, setQuery] = useState<string>(stringifyRequestQuery(state))
  const updatedQuery = useMemo(() => stringifyRequestQuery(state), [state])

  let showTable = false
  const cityList = useSelector((state: any) => state.commonList.cityList)
  const isAdmin = cityList?.roleInfo?.id === 1 || cityList?.roleInfo?.id === 2
  const isTransactionsListPermission =
    cityList?.roleInfo?.id === 3 && cityList?.userPermissionInfo[0]?.party_is_list == true

  useEffect(() => {
    if (query !== updatedQuery) {
      setQuery(updatedQuery)
    }
  }, [updatedQuery])

  const {
    isFetching,
    refetch,
    data: response,
  } = useQuery(
    `${QUERIES.SERVICECENTERS_LIST}-${query}`,
    () => {
      return getTransactionsListing(query)
    },
    {cacheTime: 0, keepPreviousData: true, refetchOnWindowFocus: false}
  )

  return (
    <QueryResponseContext.Provider value={{isLoading: isFetching, refetch, response, query}}>
      {children}
    </QueryResponseContext.Provider>
  )
}

const useQueryResponse = () => useContext(QueryResponseContext)

const useQueryResponseData = () => {
  const {response} = useQueryResponse() as any
  // console.log("Response :: -->",response)

  if (!response || !response?.responseData) {
    return []
  }
  // console.log("Response 2 :: -->",response)

  return response?.responseData || []
}

const useQueryResponsePagination = () => {
  const defaultPaginationState: PaginationState = {
    links: [],
    ...initialQueryState,
  }

  const {response} = useQueryResponse() as any
  if (!response || !response?.payload || !response?.payload?.pagination) {
    return defaultPaginationState
  }

  return response?.payload?.pagination || []
}
const useQueryResponseLoading = (): boolean => {
  const {isLoading} = useQueryResponse()
  return isLoading
}

export {
  QueryResponseProvider,
  useQueryResponse,
  useQueryResponseData,
  useQueryResponseLoading,
  useQueryResponsePagination,
}
